import { ref, computed } from 'vue'

// [
//     {
//         "id": 9,
//         "user": 1,
//         "machine_id": "aa1",
//         "processing_software_version": "matlab1.0",
//         "created": "2024-07-02T15:35:34.044413Z",
//         "updated": "2024-07-02T15:35:34.044413Z"
//     }
// ]
export interface Leader {
  id?: number
  user: number
  machine_id: string
  processing_software_version: string
  last_seen?: string
  updated?: string
  notes?: {
    completed_jobs?: Array<{
      name?: string
      status?: string
      timing?: number
      completed_at?: string
    }>
    capabilities?: string[]
    [key: string]: unknown
  }
  created: string

  [key: string]: string | number | object | string[] | null | undefined
}

export function useLeaders() {
  const leaders = ref<Leader[]>([]) // items is now Ref<Item[]>
  let inFlightFetch: Promise<void> | null = null
  const getItems = async (): Promise<Leader[]> => {
    const response = await fetch('/api/leaders/')
    // Assert the response is OK
    if (!response.ok) {
      throw new Error('Failed to fetch Leaders')
    }
    // Assert the response is JSON
    if (!response.headers.get('content-type')?.includes('application/json')) {
      throw new Error('Invalid content type')
    }

    return await response.json()
  }

  const fetchItems = async () => {
    if (inFlightFetch) {
      return inFlightFetch
    }

    inFlightFetch = (async () => {
      leaders.value = await getItems()
    })().finally(() => {
      inFlightFetch = null
    })

    return inFlightFetch
  }

  const leaderKeys = computed(() => {
    const keys = leaders.value.length > 0 ? Object.keys(leaders.value[0]) : []
    // remove created and updated keys
    keys.splice(keys.indexOf('created'), 1)
    keys.splice(keys.indexOf('updated'), 1)
    return keys
  })

  return { leaders, fetchItems, leaderKeys }
}
